/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".multi_lines_text[_ngcontent-%COMP%] {\n  white-space: pre-line; }\n\n.fa-exclamation-triangle[_ngcontent-%COMP%] {\n  font-size: 1rem;\n  color: #dc3545; }\n\n.inline-icon[_ngcontent-%COMP%] {\n  display: inline-block; }\n\n.error-icon[_ngcontent-%COMP%] {\n  position: absolute;\n  display: inline-block; }\n\n.padding-left[_ngcontent-%COMP%] {\n  padding-left: 17px; }"];
export { styles as styles };
